var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},[_c('p',[_vm._v(_vm._s(_vm.message)+"\n\t\t"),(_vm.button)?_c('button',{staticClass:"alert__button",on:{"click":_vm.buttonAction}},[_vm._v(_vm._s(_vm.button.message))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }